import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useKeepAlive = () => {
    const send = useGenericSend();

    return useCallback(async (request?: Types.IKeepAliveRequestData) => {
        return await send({
            ID: 35884,
            responses: [35885, 35886],
            description: 'Keep-Alive',
            errorLevel: 1,
            ...request ?? {}
        });
    }, [send]);
};
